import myAxios from './myAxios';
import * as currentEpisodeActions from './currentEpisodeActions';

export function updateNewCommentBody (body) {
  return function (dispatch) {
    dispatch({ type: 'UPDATE_NEW_COMMENT_BODY', payload: body });
  };
}

export const submitNewComment = (episodeId, body) => (
  (dispatch) => {
    myAxios.post(routes().post_comment, {
      body: body,
      episode_id: episodeId
    })
    .then((response) => {
      dispatch({ type: 'ADD_NEW_COMMENT_TO_COMMENT_LIST', payload: response.data })
      dispatch(currentEpisodeActions.updatePopCommentsCounter('increment'));
      dispatch({ type: 'ADDING_NEW_COMMETN_SUCCEED' })
    })
    .catch((err) => {
      console.error(err)
    });
  }
);
